/* eslint-disable */
export default {
  Inbound: '수신',
  Outbound: '발신',
  log: '기록',
  save: '저장 후 새로 만들기',
  discard: '취소 후 새로 만들기',
  hangup: '끊기',
  reject: '음성 사서함에 보내기',
  saveDraftAndCreateNewLog: '초안 저장 및 새 통화 기록 생성',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
